import { render, staticRenderFns } from "./AreaMange.vue?vue&type=template&id=04f01f9a&scoped=true"
import script from "./AreaMange.vue?vue&type=script&lang=js"
export * from "./AreaMange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f01f9a",
  null
  
)

export default component.exports